import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import AboutLeftTab from '../About/AboutLeftTab';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import axios from "axios";


const BTechCategoryBInfo2026 = () => {
    const [admissionsEnabled, setAdmissionsEnabled] = useState(false);
    useEffect(() => {
        const getFormStatus = async () => {
            try {
                // "https://admissions.swec.ac.in/api/form-status/Admissions"
                const response = await axios.get(
                    "https://admissions.swec.ac.in/api/form-status/Admissions"
                );
                setAdmissionsEnabled(response.data?.isEnabled);
            } catch (error) {
                console.error(error);
            }
        };
        getFormStatus();
    }, []);

    return (
        <>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>Admissions</h2>


                                <div className='apply-list border-0'>
                                    <h5 className='mb-3'>I Yr. B.Tech under Category-B (JEE Main & NRI / NRI Sponsored) for 2026-2027</h5>

                                    <h5 className='pt-4 pb-2'>📌 General Instructions</h5>
                                    <ul>
                                        <li><i className="ri-checkbox-circle-line"></i> Read all instructions before applying.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> Submit <strong>either</strong> online or offline application <strong>(at the college)</strong> --not both.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> Applying under multiple categories (JEE + NRI)? Submit <strong>separate applications</strong>.</li>
                                    </ul>

                                    <h5 className='pt-3 pb-2'>📄 Documents to be Attached (Max. 200 KB each)</h5>
                                    <p>All attachments must be in <strong>PDF</strong> format; Photos and Signatures in <strong>JPEG</strong> format.</p>

                                    <h6 className='fw-bold'>If applying under <u>JEE Main Category</u>:</h6>
                                    <ul>
                                        <li><i className="ri-checkbox-circle-line"></i> Passport-size colour photograph (JPEG) <strong>(Mandatory)</strong></li>
                                        <li><i className="ri-checkbox-circle-line"></i> 10th Marks Memo (PDF) <strong>(Mandatory)</strong></li>
                                        <li><i className="ri-checkbox-circle-line"></i> 12th Marks Memo (PDF) <strong>(Mandatory)</strong></li>
                                        <li><i className="ri-checkbox-circle-line"></i> Candidate & Parent Signature (JPEG) <strong>(Mandatory)</strong></li>
                                        <li><i className="ri-checkbox-circle-line"></i> JEE Main 2026 Rank Card (PDF) <strong>(Mandatory)</strong></li>
                                        <li><i className="ri-checkbox-circle-line"></i> TGEAPCET 2026 Rank Card (PDF) <em>(Optional)</em></li>
                                    </ul>

                                    <h6 className='fw-bold mt-4'>If applying under <u>NRI / NRI Sponsored Category</u> (along with above 1 to 4):</h6>
                                    <ul>
                                        <li><i className="ri-checkbox-circle-line"></i> NRI Sponsorship Letter <strong>(Mandatory)</strong> –  &nbsp;
                                            <a className='btn btn-primary bg-gradient' target='_blank' href="https://admin.swec.ac.in/assetsswec/documents/Letter-of-Sponsorship-2026.pdf">Download Format</a>
                                        </li>
                                        <li><i className="ri-checkbox-circle-line"></i> NRI's Passport / VISA <strong>(Mandatory)</strong></li>
                                        <li><i className="ri-checkbox-circle-line"></i> NRI's Residence Proof / Driving License <strong>(Mandatory)</strong></li>
                                    </ul>

                                    <h5 className='pt-4 pb-2'>🎯 Eligibility Criteria & Merit Order</h5>
                                    <ul>
                                        <li><i className="ri-checkbox-circle-line"></i> <strong>NRI:</strong> Minimum 50% in group subjects or CGPA ≥ 5 (out of 10) in qualifying exam.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> <strong>JEE (Main):</strong> Vacant NRI quota seats filled based on JEE rank with ≥ 45% in group subjects.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> <strong>TGEAPCET:</strong> Remaining seats filled on merit from qualified candidates.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> <strong>Others:</strong> If seats still vacant, filled based on ≥ 45% (or 40% for reserved) aggregate marks.</li>
                                    </ul>

                                    <h5 className='pt-4 pb-2'>💰 Fee Details</h5>
                                    <ul>
                                        <li><i className="ri-checkbox-circle-line"></i> Tuition Fee: ₹1,37,000/- per annum</li>
                                        <li><i className="ri-checkbox-circle-line"></i> NRI/NRI Sponsored: US $5000 per annum or equivalent INR</li>
                                        <li><i className="ri-checkbox-circle-line"></i> NBA Accreditation Fee: ₹3000/-</li>
                                        <li><i className="ri-checkbox-circle-line"></i> Special/Admission/University/Misc. Fees: Applicable for all categories</li>
                                    </ul>

                                    <h5 className='pt-4 pb-2'>⚠️ Important Notes</h5>
                                    <ul>
                                        <li><i className="ri-checkbox-circle-line"></i> Do not submit both online and hardcopy forms. Duplicates will be rejected.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> Seat allotment depends on branch availability.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> As per G.O.Ms.No.13, college may verify candidate’s financial and academic credibility via interview.</li>
                                        <li><i className="ri-checkbox-circle-line"></i> Admissions as per TGSCHE guidelines for 2026–26.</li>
                                    </ul>

                                    <p className='mt-4 fw-bold text-danger'>🗓️ Last date to submit the application: <u><strong>29th July 2026 until 5:00 PM</strong></u></p>
                                    <p >
                                        <a
                                            href="https://admin.swec.ac.in/assetsswec/img/swec-admission-notification-b-cat-2026.jpeg"
                                            target="_blank" rel="noopener noreferrer"
                                            className="mt-4 fw-bold text-danger">
                                            🔊
                                            Open the B.Tech Category-B <u>Admission Notification</u> 2026

                                        </a>
                                    </p>

                                    <div className="alert alert-danger " role="alert">
                                        <span>
                                            Application form is free – Tuition fee / admission fee to be paid once seat is confirmed.</span>
                                        <i className="bi bi-info-circle"></i>
                                    </div>
                                    <div className="mt-4 d-flex justify-content-center">
                                        {admissionsEnabled ? (
                                            <>
                                                <Link
                                                    to="/admissions/btech-category-b-2026/jee-application-form"
                                                    className="btn btn-primary border border-primary bg-gradient me-2"
                                                >
                                                    <span>JEE Mains/EAPCET-2026/Intermediate</span>
                                                </Link>

                                                <Link
                                                    to="/admissions/btech-category-b-2026/nri-application-form"
                                                    className="btn btn-primary border border-primary bg-gradient"
                                                >
                                                    <span>NRI/ NRI Application</span>
                                                </Link>
                                            </>
                                        ) : (
                                            <>
                                                <span className="btn btn-primary border border-primary bg-gradient me-2 disabled">
                                                    <span>JEE Mains/EAPCET-2026/Intermediate</span>
                                                </span>

                                                <span className="btn btn-primary border border-primary bg-gradient disabled">
                                                    <span>NRI/ NRI Application</span>
                                                </span>
                                            </>
                                        )}
                                    </div>
                                    {/* <div className="mt-4 d-flex justify-content-center">
                                        <span className="btn btn-primary border border-primary bg-gradient me-2 cursor-text disabled">
                                            <span>JEE Mains/EAPCET-2026/Intermediate</span>
                                        </span>
                                        <span className=" btn btn-primary border border-primary bg-gradient  cursor-text disabled">
                                            <span>NRI/ NRI Application</span>
                                        </span> */}
                                    {/* <Link to='/admissions/btech-category-b-2026/jee-application-form' className="btn btn-primary border border-primary bg-gradient me-2">
                                            <span>JEE Mains/EAPCET-2026/Intermediate</span>
                                        </Link>
                                        <Link to='/admissions/btech-category-b-2026/nri-application-form' className=" btn btn-primary border border-primary bg-gradient ">
                                            <span>NRI/ NRI Application</span>
                                        </Link> */}
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BTechCategoryBInfo2026;
